import { http, httpFile } from './http_service';

// Get all
export function all(){
    return http().get('/fueltypes');
}
// Get all active
export function allActive(){
    return http().get('/fueltypes/active');
}
// Get Single
export function single(id){
    return http().get(`/fueltypes/${id}`);
}
// Add one
export function add(data){
    return http().post('/fueltypes', data)
}
// Update
export function update(id, data){
    return http().put(`/fueltypes/${id}`, data)
}
// Delete one
export function deleteSingle(id){
    return http().delete(`/fueltypes/${id}`);
}